
    import "src/app/AppSeller/SettingsPage/index.module.scss?farm_css_modules";
    
    export default {"classForTransition": `classForTransition-18740386`,"settingsPageContainer": `settingsPageContainer-18740386`}
    